import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import OnetConsentModal from "@/src/shared/onet-consent-modal";
import MainLoading from "@Components/MainLoading";
import { DeviceFingerprint } from "@Components/ZeroFraud";
import * as stylex from "@stylexjs/stylex";

export const OnetExternal = ({ showOnetConsentModal }: { showOnetConsentModal?: boolean }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [status, setStatus] = useState({
        isConsentReady: !showOnetConsentModal,
        isFingerprintReady: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onRequestComplete = () => {
        const encodedRedirect = searchParams.get("return");
        let redirectUrl = "/";
        if (encodedRedirect) {
            redirectUrl = decodeURIComponent(encodedRedirect);
        }

        const newUrl = new URL(redirectUrl, window.location.href);
        navigate(newUrl.pathname + newUrl.search + newUrl.hash, { replace: true });
    };

    useEffect(() => {
        if (status.isConsentReady && status.isFingerprintReady) {
            onRequestComplete();
        }
    }, [onRequestComplete, showOnetConsentModal, status]);

    const handleConsentChange = useCallback(() => {
        setStatus((cState) => ({ ...cState, isConsentReady: true }));
    }, []);

    const handleFingerPrintReady = useCallback(() => {
        setStatus((cState) => ({ ...cState, isFingerprintReady: true }));
    }, []);

    return (
        <>
            <MainLoading {...stylex.props(styles.loading)} />
            {showOnetConsentModal && <OnetConsentModal onConsentChange={handleConsentChange} />}
            {!status.isFingerprintReady && (
                <DeviceFingerprint loginScreen="onet" onRequested={handleFingerPrintReady} />
            )}
        </>
    );
};

const styles = stylex.create({
    loading: {
        height: "100vh",
    },
});
